import React from 'react';
import { PasswordInput } from '../PasswordInput/index';
import { withFormField } from '../withFormField';

export var PasswordInputField = withFormField(function (props) {
  return React.createElement(PasswordInput, props);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/PasswordInputField/PasswordInputField.js
// module id = 1194
// module chunks = 0